<template>
  <div class="table-responsive">
    <div
      id="zero_config_wrapper"
      class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
    >
      <div class="row justify-content-between">
        <!-- <div class="col-sm-12 col-md-6">
          <div class="dataTables_length" id="zero_config_length">
            <label
              >{{ $t("show")
              }}<select
                v-model="sizeperpage"
                name="entries"
                class="form-control form-control-sm mx-1"
                required
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="40">40</option>
                <option value="100">100</option> </select
              >{{ $t("entries") }}</label
            >
          </div>
        </div> -->
        <!-- <h4>Subscription List</h4> -->
        <div class="col-sm-12 col-md-6 ml-auto">
          <div class="dataTables_filter" id="zero_config_filter">
            <label
              >{{ $t("Search")
              }}<input
                type="search"
                v-model="searchQuery"
                class="form-control form-control-sm"
            /></label>
          </div>
        </div>
      </div>
      <div class="row" style="height: 22rem; overflow: auto;">
        <div class="col-sm-12">
          <table id="zero_config" class="table table-hover">
            <thead>
              <tr>
                <!-- <th style="cursor: pointer; text-align: left">
                  <input
                    type="checkbox"
                    :checked="isAllChecked()"
                    @change="handleAllCheckbox"
                  />
                </th> -->
                <th
                  :key="index"
                  v-for="(column, index) in tableColumns"
                  @click="sortBy(column[1])"
                  style="cursor: pointer; text-align: left"
                >
                  {{ column[0] }}
                  <span
                    class="arrow"
                    :class="sortOrders[column[1]] > 0 ? 'asc' : 'dsc'"
                  ></span>
                </th>
                <th>{{ $t("action") }}</th>
              </tr>
            </thead>
            <tbody v-if="this.stats.length > 0" v-click-outside="closeDropdown">
              <tr
                :key="index"
                v-for="(data, index) in paginatedData"
                style="cursor: pointer; text-align: left;"
                @click="openOptions(index)"
              >
                <!-- <td style="cursor: pointer; text-align: left">
                  <input
                    type="checkbox"
                    @change="handleCheckbox($event, data)"
                    :checked="isChecked(data)"
                  />
                </td> -->
                <td>{{ data.column1 }}</td>
                <td>{{ data.column2 }}</td>
                <td>{{ data.column3 }}</td>
                <td v-if="data.date">{{ data.date }}</td>
                <td v-else>
                  {{ $t("no-read") }}
                </td>
                <td style="max-width: 16rem;">{{ data.column4 }}</td>
                <td
                  style="font-weight: bolder;padding-left: 2rem;position:relative"
                >
                  <span style="font-size:1rem">&#x2022;&#x2022;&#x2022;</span>

                  <div class="edit-drop" v-show="index === showDropdown">
                    <span @click="$emit('openCancel', data._id)">
                      {{ $t("remove_license") }}
                    </span>
                    <!-- <span @click="doDeleteAlarm(alarm._id)">
                      {{ $t("Renew Subscription") }}
                    </span> -->
                  </div>
                </td>
                <!-- <td v-else>
                  No readings yet
                </td> -->
                <!-- <td v-if="data.date">{{ data.date }}</td>
                <td v-else>
                  No readings yet
                </td> -->
              </tr>
            </tbody>
            <tbody v-else align="center">
              <tr align="center">
                <td colspan="6">
                  <!-- {{ $t("no_sms") }} -->
                  <p>{{ $t("no_active_licenses") }}</p>
                  <p class="gray3">{{ $t("buy_licenses") }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="this.stats.length !== 0" class="row mb-4">
        <div class="col-sm-12 col-md-5">
          <div class="dataTables_info" id="zero_config_info">
            {{ $t("showing") }}
            {{ (this.pageNumber - 1) * this.sizeperpage + 1 }} {{ $t("to") }}
            {{ this.pageNumber * this.sizeperpage }} of {{ this.stats.length }}
            {{ $t("readings") }}
          </div>
        </div>
        <div class="col-sm-12 col-md-7">
          <div class="dataTables_paginate paging_simple_numbers">
            <ul class="pagination">
              <li
                class="paginate_button page-item"
                :class="{ active: pageNumber == 1 }"
                @click="pageNumber = 1"
              >
                <a href="#" class="page-link">1</a>
              </li>

              <li
                :class="{ disabled: pageNumber <= 1 }"
                class="paginate_button page-item previous"
                @click="prevPage"
              >
                <a href="#" class="page-link">{{ $t("prev") }}</a>
              </li>

              <div v-if="pageCount > 3" style="display: inherit">
                <li
                  class="paginate_button page-item"
                  :class="{ active: page.isDisabled }"
                  v-for="page in pages"
                  :key="page.name"
                  @click="pageNumber = page.name"
                >
                  <a href="#" class="page-link">{{ page.name }}</a>
                </li>
              </div>

              <li
                class="paginate_button page-item next"
                :class="{ disabled: pageNumber >= pageCount }"
                @click="nextPage"
              >
                <a href="#" class="page-link">{{ $t("next") }}</a>
              </li>
              <li
                class="paginate_button page-item"
                :class="{ active: pageNumber == pageCount }"
                v-if="pageCount > 1"
                @click="pageNumber = pageCount"
              >
                <a href="#" class="page-link">{{ pageCount }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import vClickOutside from "v-click-outside";

export default {
  name: "SubLicenceTable",
  props: {
    stats: Array,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      pageNumber: 1,
      sizeperpage: 10,
      maxVisibleButtons: 3,
      searchQuery: "",
      sortKey: "",
      sortOrders: {},
      // tableColumns: [
      //   [this.$t("date_time"), "column1"],
      //   [this.$t("phone"), "column2"],
      //   [this.$t("num_units"), "column3"],
      //   [this.$t("msg"), "column4"],
      // ],
      dataTable: [],
      checkedItems: [],
      showDropdown: null,
    };
  },
  created() {
    let sortOrders = {};
    this.tableColumns.forEach(function(key) {
      sortOrders[key[1]] = 1;
    });
    this.sortOrders = sortOrders;
  },
  watch: {
    stats: {
      handler: function() {
        this.dataTable = [];
        for (let i = 0; i < this.stats.length; i++) {
          let date = this.stats[i].createdAt;
          date = moment(date, "x", true).format("MMM Do YYYY, hh:mm a");
          this.dataTable.push({
            column1: this.stats[i].key,
            column2: this.stats[i].plan.name,
            column3: this.stats[i].units,
            date: date,
            column4: this.stats[i].units,
            _id: this.stats[i]._id,
          });
        }
      },
      deep: true,
    },
    // checkedItems: {
    //   handler: function() {
    //     console.log(this.checkedItems);
    //   },
    //   deep: true,
    // },
  },

  computed: {
    pageCount() {
      let s = this.sizeperpage;

      let data = this.dataTable;
      let l = data.length;
      let count = Math.ceil(l / s);
      let filterKey = this.searchQuery.toLowerCase();
      if (filterKey) {
        data = data.filter(function(row) {
          return Object.keys(row).some(function(key) {
            return (
              String(row[key])
                .toLowerCase()
                .indexOf(filterKey) > -1
            );
          });
        });
        l = data.length;
        count = Math.ceil(l / s);
      }

      return count;
    },
    paginatedData() {
      let start = (this.pageNumber - 1) * parseFloat(this.sizeperpage);
      let end =
        (this.pageNumber - 1) * parseFloat(this.sizeperpage) +
        parseFloat(this.sizeperpage);
      let data = this.dataTable;
      let sortKey = this.sortKey;
      let filterKey = this.searchQuery.toLowerCase();
      let order = this.sortOrders[sortKey] || 1;
      if (sortKey) {
        data = data.slice().sort(function(a, b) {
          a = a[sortKey];
          b = b[sortKey];
          return (a === b ? 0 : a > b ? 1 : -1) * order;
        });
      }
      if (filterKey) {
        data = data.filter(function(row) {
          return Object.keys(row).some(function(key) {
            return (
              String(row[key])
                .toLowerCase()
                .indexOf(filterKey) > -1
            );
          });
        });
      }

      data = data.slice(start, end);

      return data;
    },
    startPage() {
      // When on the first page
      if (this.pageNumber === 1) {
        return 2;
      }
      // When on the last page
      if (this.pageNumber === this.pageCount) {
        return this.pageCount - this.maxVisibleButtons;
      }
      // When in between
      return this.pageNumber - 1;
    },
    pages() {
      const range = [];

      if (this.startPage === 1) {
        //console.log("stsrtd");
        for (
          let i = this.startPage + 1;
          i <=
          Math.min(this.startPage + this.maxVisibleButtons - 1, this.pageCount);
          i++
        ) {
          range.push({
            name: i,
            isDisabled: i === this.pageNumber,
          });
        }
      } else if (
        this.startPage ===
        this.pageCount - this.maxVisibleButtons + 1
      ) {
        //console.log("gotcha");
        for (
          let i = this.startPage;
          i <=
          Math.min(
            this.startPage + this.maxVisibleButtons - 1,
            this.pageCount - 1
          );
          i++
        ) {
          range.push({
            name: i,
            isDisabled: i === this.pageNumber,
          });
        }
      } else {
        for (
          let i = this.startPage;
          i <=
          Math.min(this.startPage + this.maxVisibleButtons - 1, this.pageCount);
          i++
        ) {
          range.push({
            name: i,
            isDisabled: i === this.pageNumber,
          });
        }
      }

      return range;
    },
    tableColumns() {
      return [
        // [this.$t("date_time"), "column1"],
        // [this.$t("phone"), "column2"],
        // [this.$t("num_units"), "column3"],
        // [this.$t("msg"), "column4"],
        [this.$t("licenceID"), "column1"],
        [this.$t("plan"), "column2"],
        [this.$t("noOfUnit"), "column3"],
        [this.$t("dateOfPurchase"), "column4"],
        [this.$t("unitRemaining"), "column5"],
      ];
    },
  },
  methods: {
    nextPage() {
      if (this.pageNumber < this.pageCount) {
        this.pageNumber++;
      }
    },
    prevPage() {
      if (this.pageNumber > 1) {
        this.pageNumber--;
      }
    },
    sortBy: function(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
    },
    handleCheckbox(e, data) {
      let temp = [...this.checkedItems];
      const index = temp.findIndex(({ column1 }) => column1 === data.column1);
      if (index > -1) {
        temp.splice(index, 1);
        return (this.checkedItems = temp);
      } else {
        temp.push(data);
        return (this.checkedItems = temp);
      }
    },
    handleAllCheckbox() {
      if (this.checkedItems.length !== this.paginatedData.length) {
        this.checkedItems = this.paginatedData;
      } else this.checkedItems = [];
    },
    isChecked(data) {
      let isChecked = this.checkedItems.map(({ column1 }) => column1);
      let checked = false;
      if (isChecked.includes(data && data.column1)) {
        return (checked = true);
      }
      return checked;
    },
    isAllChecked() {
      let checked = false;
      if (this.checkedItems.length === this.paginatedData.length) {
        checked = true;
      }
      this.$emit("show", this.checkedItems.length);
      return checked;
    },
    openOptions(e) {
      this.showDropdown = e;
    },
    closeDropdown() {
      this.showDropdown = null;
    },
  },
};
</script>

<style scoped>
td {
  border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
}

th,
td {
  min-width: 150px;
}
th.active {
  color: #fff;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 8px solid #000000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 8px solid #000000;
}
.edit-drop {
  position: absolute;
  display: flex;
  flex-flow: column;
  right: 4rem;
  top: 2.5rem;
  background: #ffffff;
  /* border: 0.3px solid rgba(183, 195, 205, 0.4); */
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(128, 101, 101, 0.04);
  border-radius: 1px;
  z-index: 2;
  min-width: 12rem;
}
.edit-drop span {
  padding: 0.5rem 2rem;
  border: 0.3px solid rgba(183, 195, 205, 0.4);
  cursor: pointer;
}
.edit-drop span:hover {
  background-color: rgba(236, 236, 236, 0.33);
}
</style>

<i18n>
{
	"en": {
		"Search": "Search",
    "action": "Action",
		"alm_type": "Alarm Type",
		"alm_val": "Alarm Value",
		"batt": "Battery {name}",
		"buy_licenses": "Buy Licences to get started.",
		"comment": "Comment",
		"date_time": "Date/Time",
		"dev-name": "Device Name",
		"dev-tag": "Device Tag",
		"dev_imei": "Device IMEI",
		"entries": "entries",
		"last-seen": "Last Seen",
		"msg": "Message",
		"next": "Next",
		"no-dev": "You have no devices yet",
		"no-read": "No readings yet",
		"no-search": "No search result found",
		"no_active_licenses": "You have no active licences yet",
		"no_alm_yet": "You have no alarm yet",
		"no_sms": "You have no sms currently",
		"num_units": "Number of Units",
		"of": "of",
		"phone": "Phone Number",
		"prev": "Previous",
		"readings": "readings",
		"remove_license": "Remove License",
		"show": "Show",
		"showing": "Showing",
		"stat": "Status",
		"to": "to"
	},
	"es": {
		"Search": "Buscar",
    "action": "action",
		"alm_type": "Tipo de alarma",
		"alm_val": "Valor de alarma",
		"batt": "Batería {name}",
		"buy_licenses": "Compre licencias para comenzar.",
		"comment": "Comentario",
		"date_time": "Fecha y hora",
		"dev-name": "Nombre del dispositivo",
		"dev-tag": "Etiqueta de dispositivo",
		"dev_imei": "IMEI del dispositivo",
		"entries": "entradas",
		"last-seen": "Ultima vez visto",
		"msg": "Mensaje",
		"next": "Siguiente",
		"no-dev": "Aún no tienes dispositivos",
		"no-read": "Aún no hay lecturas",
		"no-search": "No se encontraron resultados de búsqueda",
		"no_active_licenses": "Aún no tienes licencias activas",
		"no_alm_yet": "Todavía no tienes alarma",
		"no_sms": "Actualmente no tienes sms",
		"num_units": "Número de unidades",
		"of": "de",
		"phone": "Número de teléfono",
		"prev": "Anterior",
		"readings": "Lecturas",
		"remove_license": "Eliminar licencia",
		"show": "Show",
		"showing": "Demostración",
		"stat": "Estado",
		"to": "a"
	},
	"fr": {
		"Search": "Chercher",
    "action": "Hatua",
		"alm_type": "Type d'alarme",
		"alm_val": "VALEUR D'ALARME",
		"batt": "Batterie {name}",
		"buy_licenses": "Achetez des licences pour commencer.",
		"comment": "Commentaire",
		"date_time": "Date / heure",
		"dev-name": "Nom de l'appareil",
		"dev-tag": "Balise d'appareil",
		"dev_imei": "IMEI de l'appareil",
		"entries": "Les entrées",
		"last-seen": "Vue la dernière fois",
		"msg": "Message",
		"next": "Suivant",
		"no-dev": "Vous n'avez pas encore d'appareils",
		"no-read": "Pas encore de lectures",
		"no-search": "Aucun résultat de recherche trouvé",
		"no_active_licenses": "Vous n'avez pas encore de licences actives",
		"no_alm_yet": "Vous n'avez pas encore d'alarme",
		"no_sms": "Vous n'avez pas de sms actuellement",
		"num_units": "Nombre d'unités",
		"of": "De",
		"phone": "Numéro de téléphone",
		"prev": "précédent",
		"readings": "Lectures",
		"remove_license": "Supprimer la licence",
		"show": "Spectacle",
		"showing": "Montrant",
		"stat": "Statut",
		"to": "à"
	},
	"sw": {
		"Search": "Tafuta",
		"alm_type": "Aina ya Kengele",
		"alm_val": "Thamani ya Kengele",
		"batt": "Betri {name}",
		"buy_licenses": "Nunua Leseni ili uanze.",
		"comment": "Maoni",
		"date_time": "Tarehe/Saa",
		"dev-name": "Jina la kifaa",
		"dev-tag": "Lebo ya Kifaa",
		"dev_imei": "IMEI ya kifaa",
		"entries": "Viingilio",
		"last-seen": "Mara ya mwisho kuonekana",
		"msg": "Ujumbe",
		"next": "Ifuatayo",
		"no-dev": "Bado huna vifaa",
		"no-read": "Bado hakuna masomo",
		"no-search": "Hakuna matokeo ya utafutaji yaliyopatikana",
		"no_active_licenses": "Bado huna leseni zinazotumika",
		"no_alm_yet": "Bado huna kengele",
		"no_sms": "Huna sms kwa sasa",
		"num_units": "Idadi ya Vitengo",
		"of": "ya",
		"phone": "Nambari ya simu",
		"prev": "Hapo awali",
		"readings": "usomaji",
		"remove_license": "Ondoa Leseni",
		"show": "Onyesha",
		"showing": "Kuonesha",
		"stat": "Hali",
		"to": "Kwa"
	}
}
</i18n>
